import { gradientTextStyles } from '@/src/card-linking/components/colors'
import { CardPreview } from '@/src/card-linking/components/CardPreview'
import { usePGPlusStepAndModalContext } from '@/src/common/contexts/PGPlusModalAndStepContext'
import {
    defaultBodyText,
    defaultDivWrapper,
    defaultHeader,
    disclaimerText,
    standardPrimaryButton,
    standardPrimaryButtonOnMouseEnter,
    standardPrimaryButtonOnMouseLeave,
} from '@/src/card-linking/components/iframeStyles'

interface CardLinkSuccessProps {
    cardId: string
    cardNetwork: string
    cardLastFour: string
    adjustTextForNonActivate: boolean
    hideGiftDetailsButton?: boolean
}

export default function CardLinkSuccess({
    cardId,
    cardNetwork,
    cardLastFour,
    adjustTextForNonActivate,
    hideGiftDetailsButton,
}: CardLinkSuccessProps) {
    const { dispatch } = usePGPlusStepAndModalContext()
    const successH2Text: string = adjustTextForNonActivate
        ? 'has been saved'
        : 'is linked and activated'
    const successBodyText: string = adjustTextForNonActivate
        ? 'To use your gift, please verify that it is linked and activated to one of your saved cards.'
        : 'Use your linked card and your card account will be credited the amount you spend, until your gift is used in full.'

    return (
        <div style={defaultDivWrapper}>
            <h2 style={defaultHeader}>
                <span style={gradientTextStyles}>Success!</span> Your card{' '}
                {successH2Text}.
            </h2>
            <p style={defaultBodyText}>{successBodyText}</p>
            <CardPreview
                cardId={cardId}
                cardNetwork={cardNetwork}
                cardLastFour={cardLastFour}
            />
            <div>
                {!hideGiftDetailsButton && (
                    <button
                        style={standardPrimaryButton}
                        onMouseEnter={(e) => {
                            standardPrimaryButtonOnMouseEnter(e)
                        }}
                        onMouseLeave={(e) => {
                            standardPrimaryButtonOnMouseLeave(e)
                        }}
                        onClick={(e) => {
                            e.preventDefault()
                            dispatch({ type: 'close-modal' })
                        }}
                    >
                        Gift Details &#x2192;
                    </button>
                )}
                <p
                    style={{
                        ...disclaimerText,
                        marginTop: 25,
                    }}
                >
                    Not all cards are eligible and not all transactions can be
                    monitored. For debit cards, run transaction as credit, do
                    not use PIS. See terms of service for full card and
                    transaction eligibility details.
                </p>
            </div>
        </div>
    )
}
